export default {"src":"/_next/static/media/meeting-room.cfb29215.svg","height":15,"width":28,"blurWidth":0,"blurHeight":0};